import styled from 'styled-components'

interface ContainerProps {
  left?: number
  top?: number
  bomtom?: number
}

export const Container = styled.div<ContainerProps>`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  height: 40px;
  top: ${(props) => `${props.top}px` ?? '0px'};
  left: ${(props) => `${props.left}px` ?? '0px'};

  box-shadow: 0px 1.85px 18px rgba(0, 0, 0, 0.15);

  padding: 0.25rem 0.5rem;

  background: #262626;
  z-index: 10;

  border-radius: 5px;

  pointer-events: none;

  button {
    pointer-events: all;
    touch-action: none;

    height: 100%;

    color: #fff;
    background: none;
    border: none;

    display: flex;
    align-items: center;

    font-size: 14px;
    font-weight: 600;

    cursor: pointer;

    svg {
      margin-right: 0.3rem;
    }

    .highlight-1,
    .highlight-2,
    .highlight-3,
    .highlight-4 {
      cursor: pointer;
      -webkit-user-select: none; /* Safari */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* IE10+/Edge */
      user-select: none; /* Standard */
      width: 27px;
      height: 27px;
      border-radius: 27px;
    }

    .highlight-1 {
      background: #f2f200 !important;
    }

    .highlight-2 {
      background: #22f200 !important;
    }

    .highlight-3 {
      background: #00f2f2 !important;
    }

    .highlight-4 {
      background: #f201f2 !important;
    }
  }

  hr {
    height: 15px;
    width: 0;
    border: none;
    border-left: 1px solid #4a4a4a;
  }
`
